import { h, Component } from 'preact'
import cn from 'classnames'
import CircleButton from '../../UI/CircleButton'
import s from './Editor.css'

interface iState {
  message: string
}

class Editor extends Component<{}, iState> {
  state = {
    message: ''
  }

  onInput = (e: Event) => {
    const { value: message } = e.target as HTMLInputElement

    this.setState({
      message
    })
  }

  render () {
    const { message } = this.state

    return (
      <div className={s.Editor}>
        <div className={s.Editor__field}>
          <input
            className={s.Editor__input}
            value={message}
            onInput={this.onInput}
            placeholder="Message"
          />

          <CircleButton className={s.Editor__smile}>
            <i className={cn(s.Editor__icon, s.Editor__icon_smile)}/>
          </CircleButton>
          <CircleButton className={s.Editor__attach}>
            <i className={cn(s.Editor__icon, s.Editor__icon_attach)}/>
          </CircleButton>
        </div>

        <CircleButton
          size="l"
          color="blue"
        >
          <i className={cn(s.Editor__icon, s.Editor__icon_voice)}/>
        </CircleButton>
      </div>
    )
  }
}

export default Editor
